import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import userActions from 'redux/actions/userActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import tooltipsSelector from 'redux/selectors/tooltips/tooltips_selector'
import HintTooltip from './hint_tooltip'

class HintTooltipContainer extends Component {

	handleClick = () => {
		if (this.props.type) {
			this.props.actions.saveTooltip(this.props.type)
		}

		this.props.onButtonClick()
	}

	componentDidMount() {
		this.props.actions.initialize(this.props.type)
	}

	render() {
		if (
			(this.props.type === null || !this.props.tooltips[this.props.type])
			&& this.props.type !== 'tooltip-test'
		) {
			return null
		}
		return (
			<HintTooltip
				arrowPosition={this.props.arrowPosition}
				animatedContent={this.props.animatedContent}
				headerImage={this.props.headerImage}
				centeredContent={this.props.centeredContent}
				shouldShowButton={this.props.shouldShowButton}
				hintText={this.props.hintText}
				hintButton={this.props.hintButton}
				onButtonClick={this.handleClick}
			/>
		)
	}
}

HintTooltipContainer.propTypes = {
	type: PropTypes.string,
	arrowPosition: PropTypes.string,
	hintText: PropTypes.string,
	hintButton: PropTypes.string,
	centeredContent: PropTypes.bool,
	headerImage: PropTypes.string,
	onButtonClick: PropTypes.func,
	animatedContent: PropTypes.bool,
	shouldShowButton: PropTypes.bool,
	actions: PropTypes.shape({
		saveTooltip: PropTypes.func.isRequired,
		initialize: PropTypes.func.isRequired,
	}),
	tooltips: PropTypes.object.isRequired,
}

HintTooltipContainer.defaultProps = {
	arrowPosition: 'top-left',
	centeredContent: false,
	onButtonClick: () => {},
	headerImage: '',
	animatedContent: false,
	shouldShowButton: true,
}

function mapStateToProps(state) {
	return tooltipsSelector(state)
}


function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		saveTooltip: userActions.saveTooltip,
		initialize: userActions.initializeTooltip,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(HintTooltipContainer)
